/**
 * Props for the PriceCell component
 */
export interface PriceCellProps {
  /** Brand data containing fuel prices and metadata */
  brand: any;
  /** Type of fuel (e.g., 'SPBT', 'A95', 'A92', 'DT') */
  fuelType: string;
  /** Whether to hide discount prices in the display */
  hideDiscounts: boolean;
  /** Function to format price values for display */
  formatPrice: (price: number | null | undefined) => string;
  /** Whether to hide fuel realization and growth cells */
  hideSales?: boolean;

  priceType?: PriceType;
}

export enum PriceType {
  MODE = 'mode',
  AVERAGE = 'average'
}
